import { GetGeotabSensorsFn } from "../../../../../../rest/Geotab";
import { Key, GeotabSensor } from "../../../../../../models";
import { EditSensorActions, EditSensorStoreState } from "../../flux";
import { FlagActions } from "../../../../../flux/Flag";
import { ErrorActions } from "../../../../../flux/Error";
import { Command1 } from "../../../../../../Command";

export class LoadGeotabSensorsCommand implements Command1<Key>
{
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();
    private readonly editActions = new EditSensorActions();
    
    constructor(private getGeotabSensors: GetGeotabSensorsFn, private getState: () => EditSensorStoreState,
        private setGeotabSensorCmd: Command1<GeotabSensor>,
        private inProgressToken: string, private errorToken: string)
    {
    }

    execute = (vehicleId: Key): void => {
        const { editSession } = this.getState();
        const sameSession = () => editSession === this.getState().editSession;
        
        this.flagActions.set(this.inProgressToken);
        this.getGeotabSensors(vehicleId)
            .then(resp => {
                if(sameSession()) {
                    const { draft } = this.getState();
                    const { GeotabSensors } = resp;
                    
                    // workaround #173
                    if(!GeotabSensors) return;
                    
                    this.editActions.setGeotabSensorsItems(GeotabSensors);
                    if(draft.GeotabId == null && GeotabSensors.length === 1) {
                        this.setGeotabSensorCmd.execute(GeotabSensors[0]);
                    }
                }
            })
            .catch(err => sameSession() && this.errorActions.setError(err, this.errorToken))
            .then(() => this.flagActions.reset(this.inProgressToken)); // finally
    };
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/Sensor/LoadGeotabSensorsCommand.ts